module.exports = __webpack_public_path__ + "static/media/m-bg-4.08ad3db1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/m/m-bg-4.png
// module id = 57
// module chunks = 3